<template>
  <div>
    <!-- 公司设立 -->
    <Incorporation ref="currentUploadRef" :isReadonly="isReadonly" v-if="businessType == 'COMPANY_INCORPORATION'"></Incorporation>

    <!-- 服务转移 -->
    <Transfer ref="currentUploadRef" :isReadonly="isReadonly" v-if="businessType == 'SERVICE_TRANSFER'"></Transfer>

    <!-- 综合性公司服务 - 定制化 -->
    <ComprehensiveCustomized ref="currentUploadRef" :isReadonly="isReadonly" v-if="businessType == 'COMPREHENSIVE_CUSTOMIZED'"></ComprehensiveCustomized>

    <!-- 基金托管服务 – 定制化 -->
    <FundAdminCustomized ref="currentUploadRef" :isReadonly="isReadonly" v-if="businessType == 'FUND_ADMIN_CUSTOMIZED'"></FundAdminCustomized>
  </div>
</template>

<script>
import Incorporation from "./components/Incorporation";
import Transfer from "./components/Transfer";
import ComprehensiveCustomized from "./components/ComprehensiveCustomized";
import FundAdminCustomized from "./components/FundAdminCustomized";
import { mapState } from "vuex";
export default {
  name: "EnrollUploadSingapore",
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Incorporation,
    Transfer,
    ComprehensiveCustomized,
    FundAdminCustomized,
  },
  data() {
    return {
      businessType: null,
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
  },
  methods: {
    // 数据初始化处理
    dataInit() {
      const applymentDetailCopy = JSON.parse(JSON.stringify(this.applymentDetail));
      // 业务类型
      this.businessType = applymentDetailCopy.businessType;
      this.$nextTick(() => {
        if (this.$refs.currentUploadRef) {
          this.$refs.currentUploadRef.pageInit(applymentDetailCopy);
        }
      });
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      return this.$refs.currentUploadRef.getParamsData();
    },
    // 触发必填校验(由父级触发)
    dataFormSubmit() {
      return this.$refs.currentUploadRef.dataFormSubmit();
    },
  },
  created() {
    // isReadonly 时，applymentDetail 已存在于 vuex，自行初始化数据
    if (this.isReadonly) {
      this.dataInit();
    }
  },
};
</script>
